import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const KuwaitReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of Kuwait Attestation :</h3>
        <p>
          Certificate attestation for a Kuwait visa is needed for several
          reasons such as student visa, residence visa, work visa, or business
          aspects. It is a part of affirmation that indicates that you are a
          genuine person or company. It proves that your certificates are
          genuine & can be permitted in the country.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time to get certificate attestation for Kuwait:</h3>
        <p>
          The time span required depends upon various factors like which country
          you necessitate the authentication for, or the sorts of documents, or
          the organization you require it from. It will take around 15 days to a
          month to accomplish.
        </p>
      </div>
    </div>
  );
};

export default KuwaitReqMain;
